import * as Api from '@ViewModels';
import moment from 'moment';
import React from 'react';
import { useAccountStripeApiPublicApiKeys } from '../../../../../queries';
import { EVENT_TIME_OPTIONS, EventRegistrationFormData } from '../utils';

interface UseEventRegistrationStateProps {
	eventData?: Api.IEventRegistrationSurvey;
	formValues: EventRegistrationFormData;
}

// Hook for derived state
export const useEventRegistrationState = ({ eventData, formValues }: UseEventRegistrationStateProps) => {
	const pastEvent = React.useMemo(() => {
		const dueDateString = eventData?.eventInformation?.startTime;
		return dueDateString ? moment(dueDateString).isBefore(new Date(), 'day') : false;
	}, [eventData]);

	const stripePublicKeys = useAccountStripeApiPublicApiKeys({
		impersonationContext: undefined, // This will be passed from parent
	});

	const publishableApiKeys = React.useMemo(() => {
		return stripePublicKeys?.data ? { publishableKey: stripePublicKeys.data } : undefined;
	}, [stripePublicKeys]);

	let endTimeOptions = EVENT_TIME_OPTIONS;
	if (formValues.startDate != null && formValues.startDate === formValues.endDate && formValues.startTime) {
		const startTimeIndex = EVENT_TIME_OPTIONS.findIndex(o => o.dataContext === formValues.startTime);
		endTimeOptions = EVENT_TIME_OPTIONS.slice(startTimeIndex + 1);
	}

	return {
		pastEvent,
		publishableApiKeys,
		endTimeOptions,
	};
};
